import * as local from './local/users';
import * as nodejs from './nodejs/users';
import * as laravel from './laravel/users';

import { API_DRIVER as DRIVER } from '../config/app';

const api = {
    local,
    nodejs,
    laravel
};

export const { list, get, create, update, remove } = api[DRIVER];
